import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Snackbar from 'components/DesignSystem/Snackbar';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import MobileFab from 'components/Layout/MobileShell/MobileFab';
import MobileListState from 'components/Layout/MobileShell/MobileListState';
import ADMIN_SECTION_TABS from 'constants/adminSectionTabs';
import { WindxPainelOption } from 'types/Windx/Models/windxPainelOption';

import ModelCard from './ModelCard';

import './index.scss';

export interface ModelsFeedback {
  variant: 'success' | 'danger';
  msg: string;
}

export interface ModelsMobileProps {
  models: WindxPainelOption[] | undefined;
  isFetching: boolean;
  pendingId: number | null;
  feedback: ModelsFeedback | null;
  onDismissFeedback: () => void;
  onEdit: (model: WindxPainelOption) => void;
  onToggleAtivo: (model: WindxPainelOption) => void;
  onDelete: (model: WindxPainelOption) => void;
  onCreate: () => void;
}

export default function ModelsMobile({
  models,
  isFetching,
  pendingId,
  feedback,
  onDismissFeedback,
  onEdit,
  onToggleAtivo,
  onDelete,
  onCreate,
}: ModelsMobileProps) {
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  const resultsCount = models?.length || 0;

  return (
    <div className="models-mobile">
      <MobileSectionHeader
        backLabel="Administração"
        title="Modelos"
        onBack={() => navigate('/admin')}
        onAvatarClick={() => setMoreOpen(true)}
      />

      <SectionTabs tabs={ADMIN_SECTION_TABS} sheetTitle="Administração" />

      <div className="models-mobile-content">
        {feedback && (
          <Snackbar
            variant={feedback.variant}
            closeButton
            onClose={onDismissFeedback}
            className="mb-3"
          >
            {feedback.msg}
          </Snackbar>
        )}

        <MobileListState
          loading={isFetching}
          isEmpty={resultsCount === 0}
          emptyMessage="Nenhum modelo cadastrado."
        >
          {models?.map((model) => (
            <ModelCard
              key={model.id}
              model={model}
              isPending={pendingId === model.id}
              onEdit={onEdit}
              onToggleAtivo={onToggleAtivo}
              onDelete={onDelete}
            />
          ))}
        </MobileListState>
      </div>

      <MobileFab label="Adicionar" onClick={onCreate} />

      <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
    </div>
  );
}
